/**
 * Searches up the DOM tree for the first element that can have a width and height,
 * in other words a non-inline element. This can be block, inline-block, or flex, for example.
 *
 * @method getBlockParentElement
 * @param {Node} any text node or html element
 * @returns {Element} first non-inline parent element of passed node
 */
const getBlockParentElement = (node) => {
  do {
    node = node.parentElement;

    if (!node) {
      return null;
    }
  } while (getComputedStyle(node).display === 'inline');

  return node;
};

export default getBlockParentElement;
